import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { fetchRecommendationRequest } from './AiRecommendations.actions';
import AiRecommendationsReducer from './AiRecommendations.reducer';
import AiRecommendationsSaga from './AiRecommendations.saga';
import AiRecommendation from '../views/AiRecommendation.view';
import { getCarouselDataByStrategy } from './AiRecommendations.selectors';
import { openQuickViewWithValues } from '../../../organisms/QuickViewModal/container/QuickViewModal.actions';
import { getPromotionsData } from '../../../organisms/Promotions/container/Promotions.selectors';
import {
  getAiRecommendationsEnabled,
  getIsTransparentImageSizeReduced,
} from '../../../../../reduxStore/selectors/session.selectors';

const mapStateToProps = (state, ownProps) => ({
  activePromotions: getPromotionsData(state),
  carouselTabData: getCarouselDataByStrategy(ownProps?.strategy, ownProps?.pageName, state),
  isAiRecommendationsEnabled: getAiRecommendationsEnabled(state),
  isTransparentImageSizeReduceEnabled: getIsTransparentImageSizeReduced(state),
});

const mapDispatchToProps = (dispatch) => ({
  getRecommendations: (payload) => dispatch(fetchRecommendationRequest(payload)),
  onQuickViewOpenClick: (payload) => {
    dispatch(openQuickViewWithValues(payload));
  },
});

const withReducer = withDynamicReducer({
  key: 'AiRecommendations',
  reducer: AiRecommendationsReducer,
});
const withSaga = useDynamicSaga({ key: 'AiRecommendationsSaga', saga: AiRecommendationsSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(AiRecommendation);
